import { Controller } from "@hotwired/stimulus";

export default class extends Controller {

  connect() {
    console.log("mutationobserver init")
    const type = this.element.dataset.type
    if (type === "paper") {
      $(".deck-price-paper").toggle(true);
      $(".deck-price-online").toggle(false);
    } else if (type === "online"){
      $(".deck-price-paper").toggle(false);
      $(".deck-price-online").toggle(true);
    }
  }
}
